import { render, staticRenderFns } from "./oddsDisabled.vue?vue&type=template&id=7da39bd8&lang=pug&"
import script from "./oddsDisabled.vue?vue&type=script&lang=js&"
export * from "./oddsDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports